import awsExports from './aws-exports';

function amplifyV5toV6Config(v5Config) {
  return {
    Auth: {
      Cognito: {
        userPoolId: v5Config.userPoolId,
        userPoolClientId: v5Config.userPoolWebClientId,
        identityPoolId: v5Config.identityPoolId
      }
    },
    API: {
      GraphQL: {
        defaultAuthMode: 'userPool',
        endpoint: v5Config.graphqlEndpoint,
        apiKey: v5Config.graphqlApiKey,
        region: v5Config.region
      }
    },
    Storage: {
      S3: {
        bucket: v5Config.Storage.bucket,
        region: v5Config.Storage.region
      }
    }
  };
}

export const amplifyV6Config = amplifyV5toV6Config(awsExports);
